import React, { useState } from 'react';
import Blog_side_bar from '../components/Blog_side_bar';
import Blog_Listing from '../components/Blog_Listing';
import Popular_blogs from '../components/Popular_blogs';

export const Blogs = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);

  const handleCategorySelect = (categorySlug) => {
    setSelectedCategory(categorySlug);
    setSelectedTopic(null); // Reset topic when a new category is selected
  };

  const handleTopicSelect = (topicSlug) => {
    setSelectedTopic(topicSlug);
  };

  return (
    <div className='container-fluid mt-5 mb-5 px-4'>
      <div className='row'>
        <div className='w-20 left_bar column_height'>
          {/* Pass setSelectedCategory to update the selected category */}
          <Blog_side_bar 
            onCategorySelect={handleCategorySelect} 
            onTopicSelect={handleTopicSelect} 
          />
        </div>
        <div className='w-55 blog_center_wrap'>
          {/* Pass the selected category slug to Blog_Listing */}
          <Blog_Listing 
            categorySlug={selectedCategory} 
            topicSlug={selectedTopic} 
          />
        </div>
        <div className='w-25 right_bar column_height'>
          <Popular_blogs/>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
